import React from "react";

import { css, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const style = css`
  #ig-loading {
    z-index: 9999999999;
    width: 49px;
    height: 49px;
  }

  .ig-loading-centered {
    left: calc(50vw) !important;
  }

  #ig-loading div {
    bottom: 10px;
    width: 9px;
    height: 5px;
    background: rgba(0, 0, 0, 0.25);
    -webkit-animation: ig-loadin-2g 1.5s infinite ease;
    animation: ig-loading 1.5s infinite ease;
  }

  #ig-loading div:nth-child(2) {
    left: 11px;
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
  }

  #ig-loading div:nth-child(3) {
    left: 22px;
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
  }

  #ig-loading div:nth-child(4) {
    left: 33px;
    -webkit-animation-delay: 0.6s;
    animation-delay: 0.6s;
  }

  #ig-loading div:nth-child(5) {
    left: 44px;
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
  }

  @keyframes ig-loading {
    0% {
      height: 5px;
      transform: translateY(0px);
      background: rgba(0, 0, 0, 0.25);
    }
    25% {
      height: 30px;
      background: #2962ff;
    }
    50% {
      height: 5px;
      background: rgba(0, 0, 0, 0.25);
    }
    100% {
      height: 5px;
      background: rgba(0, 0, 0, 0.25);
    }
  }

  @-webkit-keyframes ig-loading {
    0% {
      height: 5px;
      background: rgba(0, 0, 0, 0.25);
    }
    25% {
      height: 30px;
      background: #2962ff;
    }
    50% {
      height: 5px;
      background: rgba(0, 0, 0, 0.25);
    }
    100% {
      height: 5px;
      background: rgba(0, 0, 0, 0.25);
    }
  }
`;
const Root = styled("div")(style);

interface IgLoadingProps {
  className?: string;
}

export const IgLoading = ({ className }: IgLoadingProps) => {
  return (
    <Root className={className}>
      <Grid
        container
        id="ig-loading"
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid item></Grid>
        <Grid item></Grid>
        <Grid item></Grid>
        <Grid item></Grid>
        <Grid item></Grid>
      </Grid>
    </Root>
  );
};
